var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logout"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.8497 6.69068L8.81847 4.50318C8.74185 4.42349 8.63923 4.37939 8.53271 4.38039C8.42619 4.38138 8.3243 4.4274 8.24898 4.50851C8.17366 4.58963 8.13093 4.69936 8.13001 4.81407C8.12908 4.92878 8.17003 5.03929 8.24403 5.12181L9.58181 6.56249H4.875C4.76726 6.56249 4.66392 6.60859 4.58774 6.69064C4.51155 6.77268 4.46875 6.88396 4.46875 6.99999C4.46875 7.11603 4.51155 7.22731 4.58774 7.30935C4.66392 7.3914 4.76726 7.43749 4.875 7.43749H9.58181L8.24403 8.87818C8.20523 8.91854 8.17428 8.96682 8.15299 9.02019C8.1317 9.07357 8.12049 9.13098 8.12002 9.18907C8.11955 9.24716 8.12983 9.30477 8.15026 9.35854C8.17069 9.4123 8.20085 9.46115 8.239 9.50223C8.27714 9.54331 8.3225 9.57579 8.37243 9.59779C8.42235 9.61979 8.47585 9.63086 8.52979 9.63035C8.58373 9.62985 8.63704 9.61778 8.6866 9.59485C8.73617 9.57192 8.78099 9.53859 8.81847 9.49681L10.8497 7.30931C10.9259 7.22726 10.9687 7.116 10.9687 6.99999C10.9687 6.88399 10.9259 6.77273 10.8497 6.69068Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.0625 10.9375H2.84375V3.0625H4.0625C4.17024 3.0625 4.27358 3.01641 4.34976 2.93436C4.42595 2.85231 4.46875 2.74103 4.46875 2.625C4.46875 2.50897 4.42595 2.39769 4.34976 2.31564C4.27358 2.23359 4.17024 2.1875 4.0625 2.1875H2.4375C2.32976 2.1875 2.22642 2.23359 2.15024 2.31564C2.07405 2.39769 2.03125 2.50897 2.03125 2.625V11.375C2.03125 11.491 2.07405 11.6023 2.15024 11.6844C2.22642 11.7664 2.32976 11.8125 2.4375 11.8125H4.0625C4.17024 11.8125 4.27358 11.7664 4.34976 11.6844C4.42595 11.6023 4.46875 11.491 4.46875 11.375C4.46875 11.259 4.42595 11.1477 4.34976 11.0656C4.27358 10.9836 4.17024 10.9375 4.0625 10.9375Z",
    fill: "#999999"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon-logout.8f45b410782a813f277e6c8f10ff6d9d.svg";
export { ForwardRef as ReactComponent };